<template>
  <cs-preloader-overlay :loading="loading">
    <div class="overlay-container">
      <div class="main-container">
        <div class="header-container">
          <desktop-capusta-title
            v-if="isDesktop"
            :title="$t('widget.ready.to.work')"
            :history-mode="widget.type !== 'DONATION_GOAL'"
            :redirect="getRouteRedirectByType"
          />
          <mobile-capusta-title
            v-else
            :title="$t('widget.ready.to.work')"
            :history-mode="widget.type !== 'DONATION_GOAL'"
            :redirect="getRouteRedirectByType"
          />
        </div>

        <div class="form-container">
          <div class="section-container">
            <substrate-mount>
              <div class="input-container">
                <capusta-copy-field
                  :label="$t('link.to.obs.studio')"
                  :value="widget.url"
                />
              </div>
              <a
                href="https://help.capusta.space/widget_integration"
                target="_blank"
                rel="noopener noreferrer"
                class="information-link-container"
              >
                <p>{{ $t('how.embed.in.stream') }}</p>
                <i></i>
              </a>
            </substrate-mount>
          </div>

          <div class="button-primary-container">
            <cs-button :width="buttonWidth" @click="handleReady">
              {{ $t('common.run') }}
            </cs-button>
          </div>

          <div class="button-primary-container">
            <cs-button type="secondary" :width="buttonWidth" @click="sendTestEvent">
              {{ $t('streamer.widgets.button.event.test') }}
            </cs-button>
          </div>

          <div class="button-secondary-container">
            <cs-button type="secondary" :width="buttonWidth" @click="goToCabinet">
              {{ $t('to.main.page') }}
            </cs-button>
          </div>
        </div>
      </div>

      <iframe id="streamsIframe" style="display:none;" :src="widget.url"></iframe>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import MobileCapustaTitle from 'molecules/mobile/CapustaTitle';
import DesktopCapustaTitle from 'molecules/desktop/CapustaTitle';

import SubstrateMount from '@/components/capusta/SubstrateMount';
import CapustaCopyField from '@/components/capusta/CopyField';

export default {
  name: 'StreamerWidgetsReady',
  components: {
    MobileCapustaTitle,
    DesktopCapustaTitle,
    SubstrateMount,
    CapustaCopyField,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.checkParams();
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    buttonWidth() {
      return this.isDesktop ? 223 : '100%';
    },
    getRouteRedirectByType() {
      if (this.widget.type !== 'DONATION_GOAL') {
        return '';
      }

      return 'streamer.widgets.goal';
    },
    ...mapGetters(['isDesktop']),
  },
  methods: {
    checkParams() {
      if (this.$validate.isObjectWithFields(this.widget, ['id', 'url', 'code'])) {
        return true;
      }

      return this.$router.go(-1);
    },
    goToCabinet() {
      this.$router.push({ name: 'cabinet' });
    },
    handleReady() {
      const iframeWindow = document.getElementById('streamsIframe').contentWindow;
      iframeWindow.postMessage({ 'configuration_access': 1 }, this.widget.url);

      window.location.assign(this.widget.url);
    },
    async sendTestEvent() {
      try {
        await this.initiateTestEvent(this.widget.id);

        this.$alert({
          type: 'success',
          text: 'notification.streamer.widgets.event.test.success',
        });
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'notification.streamer.widgets.event.test.error',
        });
      }
    },
    ...mapActions('streamerWidgets', ['initiateTestEvent']),
  },
};
</script>

<style lang="sass" scoped>
  @import '~styles/components/widgets/widget-form'

  .overlay-container
    overflow: hidden

  .main-container
    width: 100%
    max-width: 500px
    position: relative
    margin: 0 auto
    padding: 20px 0 60px

    +respond-to('medium')
      padding: 70px 0

    &::before
      content: ''
      width: 18rem
      height: 10rem
      display: block
      position: absolute
      top: 0
      right: 0
      background-image: url('~@/assets/svg/mobile/bill/gradient-stars.svg')
      background-repeat: no-repeat
      background-size: cover
      z-index: -1

      +respond-to('small')
        width: 20rem
        height: 15rem
        background-image: url('~@/assets/svg/bill/gradient-stars.svg')

      +respond-to('medium')
        width: 40rem
        height: 33rem
        top: -10px
        right: -22rem
        background-size: auto

  .header-container
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('small')
      margin-bottom: 30px
      padding: 0

  .form-container
    width: 100%
    max-width: 500px
    position: relative
    margin: 0 auto

  .input-container
    &:not(:last-child)
      margin-bottom: 20px

    .input,
    .textarea
      margin: 0
      white-space: nowrap

  .section-container
    margin-bottom: 20px

  .information-link-container
    display: flex
    align-items: stretch
    justify-content: space-between
    font-weight: 500
    font-size: 16px
    line-height: 20px
    color: #7CB342

    p
      text-decoration: underline

    i
      width: 22px
      height: 22px
      flex: none
      display: block
      background-image: url('~@/assets/svg/common/information.svg')
      background-position: center
      background-repeat: no-repeat
      background-size: auto
</style>
